import * as keycloakRoles from './keycloakRoles';
import * as seletores from './seletores';

export type KeycloakRole = typeof keycloakRoles[keyof typeof keycloakRoles];
export type Seletor = typeof seletores[keyof typeof seletores];

export const crudOperations = {
  create: 'create',
  read: 'read',
  update: 'update',
  delete: 'delete',
  log: 'log'
} as const;

export type CrudOperation = typeof crudOperations[keyof typeof crudOperations];

type CrudRoleBase<T> = T extends `${infer Prefix}_${CrudOperation}`
  ? Prefix
  : never;

export type CrudRole = CrudRoleBase<KeycloakRole>;

export const extractCrudRole = (role?: KeycloakRole): CrudRole | undefined => {
  if (!role) {
    return undefined;
  }
  for (const key in crudOperations) {
    const operation = crudOperations[key];
    if (role.endsWith(`_${operation}`)) {
      return role.replace(`_${operation}`, '') as CrudRole;
    }
  }
};

export { keycloakRoles, seletores };
